import { AuthSession } from "./auth.types";

const SESSION_KEY = "legacyLink.auth.session";
const KEEP_SIGNED_IN_KEY = "legacyLink.auth.keepSignedIn";

const canUseStorage = () => typeof window !== "undefined";

export const saveAuthSession = (
  session: AuthSession,
  keepSignedIn: boolean,
) => {
  if (!canUseStorage()) {
    return;
  }

  const targetStorage = keepSignedIn
    ? window.localStorage
    : window.sessionStorage;
  targetStorage.setItem(SESSION_KEY, JSON.stringify(session));
  targetStorage.setItem(KEEP_SIGNED_IN_KEY, String(keepSignedIn));
};

export const getAuthSession = (): AuthSession | null => {
  if (!canUseStorage()) {
    return null;
  }

  const persistedSession =
    window.localStorage.getItem(SESSION_KEY) ||
    window.sessionStorage.getItem(SESSION_KEY);

  if (!persistedSession) {
    return null;
  }

  try {
    return JSON.parse(persistedSession) as AuthSession;
  } catch {
    clearAuthSession();
    return null;
  }
};

export const clearAuthSession = () => {
  if (!canUseStorage()) {
    return;
  }

  window.localStorage.removeItem(SESSION_KEY);
  window.localStorage.removeItem(KEEP_SIGNED_IN_KEY);
  window.sessionStorage.removeItem(SESSION_KEY);
  window.sessionStorage.removeItem(KEEP_SIGNED_IN_KEY);
};
